import "abortcontroller-polyfill";

export const abortableFetch = (request, opts) => {
  const controller = new AbortController();
  const signal = controller.signal;

  return {
    abort: () => controller.abort(),
    ready: fetch(request, { ...opts, signal }),
  };
};

export const adblockEnabled = () =>
  // eslint-disable-next-line no-prototype-builtins
  !(typeof window.nads !== "undefined" && window.nads.hasOwnProperty("createAd"));

export const arrayBufferToBase64 = (buffer) => {
  var binary = "";
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

export const flatten = (arr) =>
  arr.reduce(function(flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
  }, []);

export const getCardSize = (cardSize) => {
  switch (cardSize) {
    case "xs":
      return { cardSize, height: 170, width: 122 };
    case "sm":
      return { cardSize, height: 255, width: 183 };
    case "lg":
      return { cardSize, height: 425, width: 305 };
    case "xl":
      return { cardSize, height: 510, width: 366 };
    case "md":
    default:
      return { cardSize, height: 340, width: 244 };
  }
};

export const isValidEmail = (str) =>
  str.match(
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
  );

export const scrollToTop = () => setTimeout(() => window.scrollTo(0, 0));
